/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { DataActionConditionType } from 'cio/utils/campaigns/data-action';

interface CreateOrUpdatePersonDetailsTooltipContentArgs {
  rows: {
    name: string;
    type: DataActionConditionType;
    value: string;
    showRemove: boolean;
  }[];
}
export default class CreateOrUpdatePersonDetailsTooltipContentEditor extends Component<CreateOrUpdatePersonDetailsTooltipContentArgs> {}
